/**
 * 
 * @param {Object} o - object
 * @returns {Object} - copy of o with all keys lowercased
 */


const keysToLowerCase = o => Object.keys(o).reduce((c, k) => (c[k.toLowerCase()] = o[k], c), {});

export default keysToLowerCase;